<template>
  <ConfigProvider :locale="getAntdLocale">
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts" setup>
import { shallowRef } from 'vue'
import { ConfigProvider } from 'ant-design-vue'
import { AppProvider } from '/@/components/Application'
import { useTitle } from '/@/hooks/web/useTitle'
import { useLocale } from '/@/locales/useLocale'
import { useProvideMapContext } from '/@/components/Map'

import 'dayjs/locale/zh-cn'
// support Multi-language
const { getAntdLocale } = useLocale()
console.log(getAntdLocale.value.locale, 'getAntdLocale---')

const map = shallowRef<AMap.Map | null>(null)
useProvideMapContext(map)
useTitle()
</script>
